var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { IValidationRepositoryType } from '../IValidationRepository';
import { IDebugRepositoryType } from '../../Application/IDebugRepository';
import { injectable } from '../../../../Data/Decorators/Injectable';
import { inject } from '../../../../Data/Decorators/Inject';
let ValidateUseCase = class ValidateUseCase {
    constructor(repository, debugRepository) {
        this.repository = repository;
        this.debugRepository = debugRepository;
        this.flags = ['/g', '/i', '/m', '/gi', '/gim', '/im'];
    }
    execute(path, value) {
        const validation = this.repository.get(path);
        if (!validation) {
            this.debugRepository.send({
                type: 'validation_error',
                data: `No validations for path ${path}`
            });
            return Object.entries(value).reduce((acc, [key, value]) => {
                acc[key] = {
                    error: false,
                    required: false
                };
                return acc;
            }, {});
        }
        return Object.entries(value).reduce((acc, [key, value]) => {
            if (!validation[key]) {
                acc[key] = {
                    error: false,
                    required: false
                };
                return acc;
            }
            let regexText = validation[key].regex;
            if (regexText.startsWith('/')) {
                regexText = regexText.slice(1);
            }
            if (regexText.endsWith('/')) {
                regexText = regexText.slice(0, regexText.length - 1);
            }
            const flag = this.flags.find(flag => regexText.endsWith(flag));
            if (flag) {
                regexText = regexText.slice(0, regexText.length - flag.length - 1);
            }
            const regex = new RegExp(regexText, flag === null || flag === void 0 ? void 0 : flag.slice(1));
            acc[key] = {
                error: !regex.test(`${value}`),
                required: !!validation[key].required
            };
            if (!`${value}` && validation[key].required) {
                acc[key].error = true;
            }
            return acc;
        }, {});
    }
};
ValidateUseCase = __decorate([
    injectable(),
    __param(0, inject(IValidationRepositoryType)),
    __param(1, inject(IDebugRepositoryType)),
    __metadata("design:paramtypes", [Object, Object])
], ValidateUseCase);
export { ValidateUseCase };
